/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncCapsAccountHolder} from '../api'

export const useMutationSyncCapsAccountHolder = createReactQueryMutationHook('syncCapsAccountHolder', syncCapsAccountHolder)
